import * as React from 'react'

import * as styles from './UserVerificationResend.module.scss'
import { generateTokenService } from 'services/token'
import { CONFIRMATION_TYPES } from 'components/forms/confirmation-modal/constants'
import { setTokenData } from 'util/countdown-store'
import { Turnstile } from '@marsidev/react-turnstile'
import { useRef } from 'react'

export const UserVerificationResend = ({
  email = 'a@gmail.com',
  firstName,
  lastName,
  tokenSource = 'RECEIPT_UPLOAD',
  permalink = 'a-b',
  goToVerification,
  goBackToSignUp,
  verificationCodeExpiration = 900, // Test with 30 seconds
  manualResendCooldown = 180, // 3 minutes
  formClassName = styles.formWrapper,
  hideResendText = false,
  // Custom token services
  customGenerateTokenService = null,
  tokenServicePayload = {},
  onTokenAlreadyRequested = null,
}) => {
  const turnstileResendRef = React.useRef(null)
  const [loading, setLoading] = React.useState(false)
  const onSendToken = async ({
    firstName,
    lastName,
    email,
    permalink,
    tokenSource,
    tokenSourceId,
  }) => {
    // Use custom token generation service if provided, otherwise use default
    const tokenService = customGenerateTokenService || generateTokenService
    const turnstileToken = turnstileResendRef.current?.getResponse()

    if (!turnstileToken) {
      throw new Error('Turnstile token is required')
    }

    return await tokenService({
      firstName,
      lastName,
      email,
      permalink,
      tokenSource: tokenSource || '',
      tokenSourceId: tokenSourceId || '',
      ...tokenServicePayload,
      turnstileToken: turnstileToken,
    })
  }

  const handleResend = async () => {
    setLoading(true)
    const confirmationData = {
      email,
      firstName,
      lastName,
      tokenSource,
      permalink,
      type: CONFIRMATION_TYPES.EMAIL,
    }
    try {
      await onSendToken(confirmationData)
    } catch (error) {
      const status = error?.status
      const detail = (error?.detail || error?.message || '').toString()
      const detailLower = detail.toLowerCase()

      const looksAlreadyRequested =
        status === 409 ||
        status === 429 ||
        detailLower.includes('already') ||
        detailLower.includes('already been sent') ||
        detailLower.includes('already sent') ||
        detailLower.includes('already requested')

      if (looksAlreadyRequested && typeof onTokenAlreadyRequested === 'function') {
        onTokenAlreadyRequested()
      } else {
        throw error
      }
    } finally {
      setLoading(false)
      goToVerification()
      const now = Date.now()
      await setTokenData(email, {
        tokenExpiresAt: now + verificationCodeExpiration * 1000,
        canSendAnNewTokenAt: now + manualResendCooldown * 1000,
      })
    }
  }

  return (
    <div className={`${formClassName}`}>
      <div className={styles.wrapper}>
        <span className={styles.header}>Resend Your Verification Email</span>
        <Turnstile
          ref={turnstileResendRef}
          siteKey={process.env.VISIBLE_TURNSTILE_SITE_KEY}
        />
        <button
          disabled={loading}
          onClick={handleResend}
          className="btn"
          type="submit"
        >
          Get a New Code
        </button>
        {!hideResendText && (
          <span className={styles.content}>
            <span onClick={goBackToSignUp}>
              If you’d like to edit your email address, you’ll need to go back
              to Sign Up in order to complete the verification process.
            </span>
          </span>
        )}
      </div>
    </div>
  )
}
